import {
    ADD_NEW_STAFF_SUCCESS,
    ADD_NEW_STAFF_FAILURE,
} from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
    switch (action.type) {
        case ADD_NEW_STAFF_SUCCESS:
            return {
                ...state,
                data: action.payload,
                isLoading: false,
            };
        case ADD_NEW_STAFF_FAILURE:
            return {
                ...state,
                isLoading: false,
                errorData: action.payload,
                error: true,
            };
        default:
            return { ...state };
    }
};
